/**
 * Recently used shift templates of this browser (#2038): the create dialog shows the
 * template chips last used first. Stored in localStorage only; nothing goes to the server.
 */
const STORAGE_KEY = 'daycare-butler.shifts.recentTemplates';
const MAX_REMEMBERED = 20;

export function readRecentTemplateIds(): string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : [];
  } catch {
    return [];
  }
}

export function rememberTemplateUse(templateId: string): string[] {
  const next = [templateId, ...readRecentTemplateIds().filter((id) => id !== templateId)].slice(0, MAX_REMEMBERED);
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // A full or blocked storage only loses the ordering.
  }
  return next;
}

/** Templates ordered by recent use, the never-used ones after them in their own order. */
export function orderTemplatesByRecentUse<T extends { id?: string }>(templates: T[], recentIds: string[]): T[] {
  const rank = new Map(recentIds.map((id, index) => [id, index]));
  return templates
    .map((template, index) => ({ template, index }))
    .sort((a, b) => {
      const ra = rank.get(a.template.id ?? '') ?? Number.MAX_SAFE_INTEGER;
      const rb = rank.get(b.template.id ?? '') ?? Number.MAX_SAFE_INTEGER;
      return ra - rb || a.index - b.index;
    })
    .map(({ template }) => template);
}
